<ng-container [formGroup]="formGroupCampaign">
    <div class="row d-flex justify-content-between mb-3">
        <div class="col-4">
            <div class="d-flex flex-row align-items-center justify-content-center">
                <div class="body-1 mr-1 ">Cover Image</div>
                    <app-text-popover
                      placement="bottom"
                      type="content"
                      text="This will be seen by donors viewing this campaign on tablets and computers. It is also included in donor emails corresponding to this campaign."
                      title=""
                    >
                    </app-text-popover>
            </div> 
            <div class="image-block mb-1" style="min-height: 150px;">
                <div
                    *ngIf="formGroupCampaign.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                    class="image-block__file-container d-flex align-items-center justify-content-center"
                >
                    <app-input-file formControlName="imageFile" [classes]="['btn--paybee-custom']" class="position-absolute" accept="image/png,image/jpeg" label="Upload"></app-input-file>
                </div>
                <div
                    *ngIf="formGroupCampaign.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                    class="image-block__file-container d-flex align-items-start justify-content-end"
                >
                    <app-icon-delete (click)="resetImageByType('image')" class="position-absolute cursor--pointer m-2"></app-icon-delete>
                </div>
                <img class="image-block__image" [src]="formGroupCampaign.controls.imageDataUrl.value" style="min-height:150px">
            </div>
            <div class="d-flex justify-content-center flex-column">
                @if(formGroupCampaign.controls.imageDataUrl.value === '/images/blank_2x1.png'){
                   <span class="blue-text body-2 text-center">OR</span>
                    <a (click)="openChooseImageModal(0)" class="blue-text body-2 text-center">Choose from previously used images</a>
                }
            </div>
        </div>
        <!-- hidden for now -->
        <!-- <div class="col-4 flex-column justify-content-start">
            <div class="d-flex flex-row align-items-center justify-content-center">
                <div class="col-2 body-1 mr-0 pr-1">Thumbnail</div>
                    <i data-toggle="tooltip" data-placement="left" title="This will be seen by donors viewing this campaign on mobile phones" class="blue-text far fa-question-circle"></i>
            </div> 
            <div class="image-block mb-1 mx-auto" style=" height:150px; max-width:150px;">
                @if(formGroupCampaign.controls.thumbnailDataUrl.value === '/images/blank_1x1.png'){
                    <div class="image-block__file-container d-flex align-items-center justify-content-center">
                        <app-input-file formControlName="thumbnailFile" [minSize] ='200' [classes]="['btn--paybee-custom']" class="position-absolute" label="Upload" accept="image/png,image/jpeg"></app-input-file>
                    </div>
                }
                @if(formGroupCampaign.controls.thumbnailDataUrl.value !== '/images/blank_1x1.png'){
                    <div class="image-block__file-container d-flex align-items-start justify-content-end">
                        <app-icon-delete (click)="resetImageByType('thumbnail')" class="position-absolute cursor--pointer m-2"></app-icon-delete>
                    </div>
                }
                <img class="image-block__image" [src]="formGroupCampaign.controls.thumbnailDataUrl.value">
            </div>
            <div class="pr-0 d-flex justify-content-center flex-column">
                @if(formGroupCampaign.controls.thumbnailDataUrl.value === '/images/blank_1x1.png'){
                    <span class="blue-text body-2 text-center">OR</span>
                    <a (click)="openChooseImageModal(1)" class="d-block blue-text body-2 text-center">Choose from previously used images</a>
                        <div [ngStyle]="{'display': formGroupCampaign.controls.imageDataUrl.value === '/images/blank_2x1.png' ? 'none' : 'flex'}" class=" flex-row align-items-center justify-content-center">
                            <a (click)="generateThumbnail()" class="blue-text body-2 mr-1 text-center">Generate Thumbnail from main image</a>
                            <i data-toggle="tooltip" data-placement="left" title="Generates a thumbnail from the campaign image" class="blue-text far fa-question-circle"></i>
                        </div>
                }
            </div>
        </div> -->
    </div>

    <mdb-form-control class="form-fill">
        <app-mdbp-input mdbInput formControlName="name" label='Campaign Name'></app-mdbp-input>
        <mdb-error class="form-fill-error"  *ngIf="formGroupCampaign.controls.name.hasError('required') && formGroupCampaign.controls.name.touched ">Please provide Campaign Name</mdb-error>
        <mdb-error class="form-fill-error"  *ngIf="formGroupCampaign.controls.name.value=='' && formGroupCampaign.controls.name.touched ">Please provide Campaign Name</mdb-error>
    </mdb-form-control>
    <div class="position-relative mb-4">
        <div class="d-flex flex-row align-items-center">
            <label class="form-check-label form-check-label--paybee mb-1 mr-2">Campaign description</label>
            <app-text-popover
                placement="bottom"
                type="content"
                [text]="campaignDescPopover"
                title=""
            >
            </app-text-popover>
        </div>
        <mdb-form-control>
            <app-quill-custom mdbInput formControlName="desc" limit="2048"></app-quill-custom>
        </mdb-form-control>
    </div>
    <div class="position-relative mb-4">
        <div class="d-flex align-items-center mb-2">
            <div class="d-flex flex-row align-items-center">
                <label class="form-check-label form-check-label--paybee text-nowrap mr-2">Campaign summary</label>
                <app-text-popover
                    placement="bottom"
                    type="content"
                    text="Add a short summary to describe this campaign."
                    title=""
                >
                </app-text-popover>
            </div>
            @if(formGroupCampaign.get('desc').value !== ''){
                <div class="d-flex justify-content-end w-100">
                    <a (click)="generateSummary(0)" class="blue-text body-2">Generate Summary From Description</a>
                </div>
            }
        </div>
        <mdb-form-control>
            <app-quill-custom mdbInput formControlName="summary" [options]="quillOptions" limit="256"></app-quill-custom>
        </mdb-form-control>
    </div>

    <div class="row">
        <div class="col">
            <app-datepicker formControlName="startDateUnix" [myDatePickerOptions]="startDateOptions" label="Start Date"></app-datepicker>
        </div>
        <div class="col">
            <app-datepicker formControlName="endDateUnix" [myDatePickerOptions]="endDateOptions" label="End Date"></app-datepicker>
        </div>
    </div>
    <mdb-accordion [multiple]="true">
        <mdb-accordion-item [collapsed]="!panel.expanded"  (itemShown)="onAfterExpand()" (itemHidden)="onAfterCollapse()">
          <ng-template mdbAccordionItemHeader>General Settings</ng-template>
          <ng-template mdbAccordionItemBody>
            <div *ngIf="settings.qualifiedTaxDeductible">
                <app-mdb-switch label="Qualify for donor tax deduction" formControlName="qualifiedTaxDeductible"></app-mdb-switch>
                <div class="divider"></div>
            </div>
            <div *ngIf="settings.isDefault">
                <app-mdb-switch label="Hide from main campaign page" formControlName="isDefault"></app-mdb-switch>
                <div class="divider"></div>
            </div>
            <div *ngIf="settings.dedicationEnabled">
                <app-mdb-switch label="Show donors option to dedicate donation to someone" formControlName="dedicationEnabled"></app-mdb-switch>
                <div class="divider"></div>
            </div>
            <div *ngIf="settings.streetAddress">
                <app-mdb-switch label="Ask donors for street address" formControlName="streetAddressRequired"></app-mdb-switch>
                <div style="padding-left: 44px;" *ngIf="formGroupCampaign.value.streetAddressRequired">
                    <mdb-form-control class="form-fill">
                        <app-mdbp-input mdbInput formControlName="streetAddressReason" data-panel="general" label='Address Reason'></app-mdbp-input>
                        <mdb-error class="form-fill-error"  *ngIf="formGroupCampaign.controls.streetAddressReason.hasError('required') && formGroupCampaign.controls.streetAddressReason.touched ">Please provide Address Reason</mdb-error>
                    </mdb-form-control>
                    <app-mdb-switch label="Street Address is Optional" formControlName="addressOptional"></app-mdb-switch>
                </div>
                <div class="divider"></div>
            </div>
            <div *ngIf="settings.phoneNumber">
                    <app-mdb-switch label="Ask donors for phone number" formControlName="phoneNumRequired"></app-mdb-switch>
                    <div style="padding-left: 44px;">
                        <app-mdb-switch *ngIf="formGroupCampaign.value.phoneNumRequired" label="Phone Number is Optional" formControlName="phoneOptional"></app-mdb-switch>
                    </div>
                    <div class="divider"></div>
            </div>
            <div *ngIf="settings.additionalInfo">
                <div class="d-flex align-items-center mat-slide-toggle__wrapper w-100">
                    <app-mdb-switch label="Any additional info required" formControlName="additionalInfoRequired"></app-mdb-switch>
                </div>
                <div style="padding-left: 44px;" *ngIf="formGroupCampaign.value.additionalInfoRequired">
                    <mdb-form-control class="form-fill" data-panel="general">
                        <app-mdbp-input mdbInput formControlName="additionalInfoDesc" data-panel="general" label='Additional info description'></app-mdbp-input>
                        <mdb-error class="form-fill-error"  *ngIf="formGroupCampaign.controls.additionalInfoDesc.hasError('required') && formGroupCampaign.controls.additionalInfoDesc.touched ">Please provide Description</mdb-error>
                    </mdb-form-control>
                    <div class="position-relative mb-4">
                        <label class="form-check-label form-check-label--paybee mb-1">Instructions for additional info (optional)</label>
                        <mdb-form-control class="mb-4">
                            <app-quill-custom mdbInput formControlName="additionalInfoDetail" limit="2048"></app-quill-custom>
                        </mdb-form-control>     
                    </div>
                    <span class="form-fill-error"  *ngIf="formGroupCampaign.controls.additionalInfoDetail.invalid" style="margin-top: -20px;">Invalid link</span>
                </div>
                <div class="divider"></div>
            </div>
            <div *ngIf="settings.additionalInfoSelect">

                <app-mdb-switch label="Any additional info, to be selected by user" formControlName="additionalInfoSelectRequired"></app-mdb-switch>
                <div style="padding-left: 44px;" *ngIf="formGroupCampaign.value.additionalInfoSelectRequired">
                    <mdb-form-control class="form-fill" data-panel="general">
                        <app-mdbp-input mdbInput formControlName="additionalInfoSelectDesc" data-panel="general" label='Additional info select description'></app-mdbp-input>
                        <mdb-error class="form-fill-error"  *ngIf="formGroupCampaign.controls.additionalInfoSelectDesc.hasError('required') && formGroupCampaign.controls.additionalInfoSelectDesc.touched">Please provide Description</mdb-error>
                    </mdb-form-control>
                    <p class="mb-0 grey-text small"> Type a option and press enter to add. Click <strong>X</strong> to remove it. </p>
                    <app-chips
                         placeholder="Press Enter to add each Tag"
                         formControlName="additionalInfoSelect"
                         [touched]="additionalInfoSelect.touched"
                         [required]="true"
                         idChips="additionalInfoSelect"
                    ></app-chips>

                </div>
                <div class="divider"></div>
            </div>
            <div *ngIf="settings.coCampaigns">
                <app-mdb-switch label="Promote other Campaigns" formControlName="coCampaignsRequired"></app-mdb-switch>
                <div style="padding-left: 44px;" *ngIf="formGroupCampaign.value.coCampaignsRequired">
                    <mdb-form-control class="form-fill" data-panel="general">
                        <mdb-select formControlName="coCampaigns" class="mdb-select" data-panel="general" [filter]="true">
                            <mdb-option *ngFor="let campaign of coCampaigns" [value]="campaign.intid">{{
                            campaign.name
                            }}</mdb-option>
                        </mdb-select>
                        <label mdbLabel class="form-label form-label--paybee">Select Co-Campaign</label>
                        <mdb-error class="form-fill-error" *ngIf="formGroupCampaign.controls.coCampaigns.hasError('required') && formGroupCampaign.controls.coCampaigns.touched">Please provide Co-Campaigns</mdb-error>
                    </mdb-form-control>
                </div>
                <div class="divider"></div>
            </div>
            <div *ngIf="settings.addOnDonationCampaign">
                <ng-container [formGroup]="campaignTypeData">
                    <app-mdb-switch label="Enable Add On Donation" formControlName="addOnDonationCampaignRequired"></app-mdb-switch>
                    <div style="padding-left: 44px;" *ngIf="campaignTypeData.value.addOnDonationCampaignRequired">
                        <mdb-form-control class="form-fill" data-panel="general">
                            <mdb-select formControlName="addOnDonationCampaignId" data-panel="general" class="mdb-select" [filter]="true">
                                <mdb-option *ngFor="let campaign of addOnCampaigns" [value]="campaign.id">{{
                                campaign.name
                                }}</mdb-option>
                            </mdb-select>
                            <label mdbLabel class="form-label form-label--paybee">Select Campaign for Add On Donation</label>
                            <mdb-error class="form-fill-error" *ngIf="campaignTypeData.controls.addOnDonationCampaignId.hasError('required') && campaignTypeData.controls.addOnDonationCampaignId.touched">Please select a Campaign</mdb-error>
                        </mdb-form-control>
                    </div>
                    <div class="divider"></div>
                </ng-container>
            </div>
            <div *ngIf="settings.redirectUrl">
                <app-mdb-switch label="Redirect Donor to URL after donation" formControlName="redirectUrlRequired"></app-mdb-switch>
                <div style="padding-left: 44px;" *ngIf="formGroupCampaign.value.redirectUrlRequired">
                    <mdb-form-control class="form-fill" data-panel="general">
                        <app-mdbp-input mdbInput formControlName="redirectUrl" data-panel="general" label='Redirect URL'></app-mdbp-input>
                        <mdb-error class="form-fill-error"  *ngIf="formGroupCampaign.controls.redirectUrl.hasError('required') && formGroupCampaign.controls.redirectUrl.touched">Please provide Redirect URL</mdb-error>
                        <mdb-error class="form-fill-error"  *ngIf="formGroupCampaign.controls.redirectUrl.hasError('pattern') && formGroupCampaign.controls.redirectUrl.touched">Incorrect format of Redirect URL</mdb-error>
                        <mdb-error class="form-fill-error"  *ngIf="formGroupCampaign.controls.redirectUrl.hasError('url') && formGroupCampaign.controls.redirectUrl.touched">Incorrect format of Redirect URL</mdb-error>
                    </mdb-form-control>
                </div>
                <div class="divider"></div>
            </div>
            <div *ngIf="settings.donationButtonLabel">
                <app-mdb-switch label="Donation button Label" formControlName="donationButtonLabelRequired"></app-mdb-switch>
                <div style="padding-left: 44px;" *ngIf="formGroupCampaign.value.donationButtonLabelRequired">
                    <mdb-form-control class="form-fill"  data-panel="general">
                        <app-mdbp-input mdbInput formControlName="donationButtonLabel" data-panel="general" label='Donation Button Label'></app-mdbp-input>
                        <mdb-error class="form-fill-error"  *ngIf="formGroupCampaign.controls.donationButtonLabel.hasError('required') && formGroupCampaign.controls.donationButtonLabel.touched">Please provide Donation Button Label</mdb-error>
                    </mdb-form-control>
                </div>
                <div class="divider"></div>
            </div>
            <div *ngIf="settings.postDonation">
                <ng-container [formGroup]="campaignTypeData">
                    <app-mdb-switch label="Post donation form" formControlName="postActivityFormUrlRequired"></app-mdb-switch>
                    <div style="padding-left: 44px;" *ngIf="campaignTypeData.value.postActivityFormUrlRequired">
                        <mdb-form-control class="form-fill" data-panel="settings">
                            <app-mdbp-input mdbInput formControlName="postActivityFormUrl" data-panel="settings" label='Form URL'></app-mdbp-input>
                            <mdb-error class="form-fill-error"  *ngIf="campaignTypeData.controls.postActivityFormUrl.hasError('required') && campaignTypeData.controls.postActivityFormUrl.touched">Please provide Form URL</mdb-error>
                            <mdb-error class="form-fill-error"  *ngIf="campaignTypeData.controls.postActivityFormUrl.hasError('pattern') && campaignTypeData.controls.postActivityFormUrl.touched">Incorrect format of Redirect URL</mdb-error>
                        </mdb-form-control>
                    </div>
                </ng-container>
            </div>
            <div *ngIf="settings.internalId">
                  <mdb-form-control class="form-fill">
                    <app-mdbp-input mdbInput formControlName="internalId" data-panel="general" label='Internal Id for campaign for reporting (optional)'></app-mdbp-input>
                </mdb-form-control>
            </div>
            <div>
                <app-mdb-switch label="Add an image below campaign options" formControlName="campaignPageImageRequired"></app-mdb-switch>
                <div style="padding-left: 44px;" *ngIf="formGroupCampaign.value.campaignPageImageRequired">
                    <div class="position-relative" style="max-width: 240px;min-height: 120px;">
                        <div
                            *ngIf="formGroupCampaign.controls.campaignPageImage.value === ''"
                            style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                            class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                        >
                            <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="Select Image" formControlName="imageBelowFile"></app-input-file>
                        </div>
                        <div
                            *ngIf="formGroupCampaign.controls.campaignPageImage.value !== ''"
                            style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                            class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                        >
                            <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetImageBelow()"></app-icon-delete>
                        </div>
                        <img style="border-radius: 5px" class="w-100" [src]="formGroupCampaign.controls.campaignPageImage.value">
                    </div>
                    <div class="text-center mb-4 mt-1" style="max-width: 240px;">
                        @if(formGroupCampaign.controls.campaignPageImage.value === ''){
                            <span class="d-block blue-text body-2 text-center">OR</span>
                            <a (click)="openChooseImageModal(0, 'imageBelow')" class="blue-text body-2">Choose from previously used images</a>
                        }
                    </div>
                </div>
                <div class="divider"></div>
            </div>
            <div>
                <app-mdb-switch label="Hide share buttons" formControlName="hideShareButtons"></app-mdb-switch>
            </div>
          </ng-template>
        </mdb-accordion-item>
      </mdb-accordion>
</ng-container>
